import { render, staticRenderFns } from "./AddRadioaktif.vue?vue&type=template&id=12c14b3c&lang=pug&"
import script from "./AddRadioaktif.vue?vue&type=script&lang=js&"
export * from "./AddRadioaktif.vue?vue&type=script&lang=js&"
import style0 from "./AddRadioaktif.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports